import { PaymentChannel } from "./V2/gozer"

export const PaymentChannels = [
    {
        name: "Lock Box",
        value: PaymentChannel.LOCK_BOX,
        channels: [PaymentChannel.LOCK_BOX]
    },
    {
        name: "Customer Portal",
        value: "CustomerPortal",
        channels: [PaymentChannel.SIGNED_IN_PORTAL, PaymentChannel.GUEST_PAY]
    },
    {
        name: "Instapay",
        value: PaymentChannel.INSTAPAY,
        channels: [PaymentChannel.INSTAPAY]
    },
    {
        name: "IVR",
        value: PaymentChannel.IVR,
        channels: [PaymentChannel.IVR]
    },
    {
        name: "Payment Entry",
        value: "PaymentEntry",
        channels: [PaymentChannel.TERMINAL, PaymentChannel.ONE_TIME_PAYMENT]
    },
    {
        name: "Recurring Payment",
        value: PaymentChannel.RECURRING_PAYMENT,
        channels: [PaymentChannel.RECURRING_PAYMENT]
    },
    {
        name: "Cash Collections",
        value: PaymentChannel.CASH_COLLECTIONS,
        channels: [PaymentChannel.CASH_COLLECTIONS]
    },
    {
        name: "uReceivables",
        value: PaymentChannel.U_RECEIVABLES,
        channels: [PaymentChannel.U_RECEIVABLES]
    },
    {
        name: "uScan",
        value: PaymentChannel.U_SCAN,
        channels: [PaymentChannel.U_SCAN]
    },
    {
        name: "Third Party CC",
        value: PaymentChannel.THIRD_PARTY_CC,
        channels: [PaymentChannel.THIRD_PARTY_CC]
    },
    {
        name: "Third Party ACH",
        value: PaymentChannel.THIRD_PARTY_ACH,
        channels: [PaymentChannel.THIRD_PARTY_ACH]
    },
    {
        name: "Returned Payment",
        value: PaymentChannel.RETURNED_PAYMENT,
        channels: [PaymentChannel.RETURNED_PAYMENT]
    },
    {
        name: "Multi Owner",
        value: PaymentChannel.MULTI_OWNER,
        channels: [PaymentChannel.MULTI_OWNER]
    }
].sort((a,b) => a?.name?.localeCompare(b?.name ?? "") ?? 0)